function NXTotalVariant() {
  return (
    <svg
      width="54"
      height="50"
      viewBox="0 0 54 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="34" cy="20" r="20" fill="#E7F7EF" />
      <circle cx="11" cy="3" r="3" fill="#E7F7EF" />
      <path
        d="M20 33.3334C21.8409 33.3334 23.3333 31.841 23.3333 30C23.3333 28.1591 21.8409 26.6667 20 26.6667C18.159 26.6667 16.6666 28.1591 16.6666 30C16.6666 31.841 18.159 33.3334 20 33.3334Z"
        stroke="#277200"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6666 30C32.2216 37.7783 26.6666 41.6667 20 41.6667C13.3333 41.6667 7.77831 37.7783 3.33331 30C7.77831 22.2217 13.3333 18.3333 20 18.3333C26.6666 18.3333 32.2216 22.2217 36.6666 30Z"
        stroke="#277200"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NXTotalVariant;
